import { useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfAgency } from '../../database';

import { useUploadController } from '../ImageUpload/UploadController';
import { useData } from 'src/contexts/data';
import { useAuth } from 'src/contexts/auth';

import api from '../../services/api';

const initialValuesOfAgency = {
    NOME_ORGAO: '',
    CNPJ_ORGAO: '',
    BAIRRO_ORGAO: '',
    CEP_ORGAO: '',
    CIDADE_ORGAO: '',
    ENDERECO_ORGAO: '',
    STATUS: 1
};
export const useListAgencysController = () => {
    const { userAgencyId } = useAuth();
    const { imageUploading } = useData();
    const { handleUpload } = useUploadController();

    const [selectedAgency, setSelectedAgency] = useState<ModelOfAgency>(initialValuesOfAgency);
    const [loading, setLoading] = useState(false);
    const [editDialog, setEditDialog] = useState(false);

    const toast: any = useRef();

    const validationSchema = Yup.object().shape({
        NOME: Yup.string().required('* Campo obrigatório'),
        CNPJ: Yup.string().required('* Campo obrigatório'),
        BAIRRO: Yup.string().required('* Campo obrigatório'),
        CEP: Yup.string().required('* Campo obrigatório'),
        CIDADE: Yup.string().required('* Campo obrigatório'),
        ENDERECO: Yup.string().required('* Campo obrigatório'),
    });

    const editAgency = (agency: ModelOfAgency) => {
        setLoading(true);

        const editedAgency: ModelOfAgency = {
            ...agency,
        };

        api.put(`agencys/${selectedAgency?.ID}`, editedAgency)
            .then(() => {
                handleUpload.processUploadFileImage(imageUploading, 'logo','ORGAO' , userAgencyId);
                setEditDialog(false);
                setLoading(false);
                toast.current.show({ severity: 'success', summary: 'Edição realizada', detail: 'Informações do órgão editadas com sucesso!', life: 5000 });
            }).catch((err) => {
                console.log(err);
                setEditDialog(false);
                setLoading(false);
                toast.current.show({ severity: 'error', summary: 'Edição não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
            });
    }

    const openEditDialog = (Agency: ModelOfAgency) => {
        setEditDialog(true);
        setSelectedAgency(Agency);
    }

    const closeEditDialog = () => {
        setEditDialog(false);
    }

    const formik = useFormik<ModelOfAgency>({
        initialValues: {
            NOME_ORGAO: '',
            CNPJ_ORGAO: '',
            BAIRRO_ORGAO: '',
            CEP_ORGAO: '',
            CIDADE_ORGAO: '',
            ENDERECO_ORGAO: '',
            STATUS: 0
        },
        onSubmit: async values => await editAgency(values),
        validationSchema
    });

    return {
        getAgencyListController: {
            formik,
            selectedAgency,
            loading,
            editDialog,
            toast
        },
        handleAgencyListController: {
            editAgency,
            openEditDialog,
            closeEditDialog,
        }
    };
};